import { Button, Modal } from "antd";
import React, { useState } from "react";
import { getLocalStorageItem, numberToWords } from "../../../Utils";
import {
  Dmt2getRefund,
  dmtFundTransfer2Otp,
  getPayoutAndDmtOtp,
  resendOtpDmt2,
} from "../../../ApiServices/Apifun";
import { Images } from "../../../Controller";
import { Globalendpoints } from "../../../ApiServices/global";
import OtpDmt2 from "./OtpDmt2";
import useOtpHook from "../../../Hooks/useOtpHook";

const DmtPayModal2 = ({ isOpen, mobile, setIsOpen, details, referenceKey }) => {
  const [inputValue, setInputValue] = useState("");
  const [btnLoading, setBtnLoading] = useState(false);
  const [originalVal, setOriginalVal] = useState("");
  const [openVerifyModal, setOpenVerifyModal] = useState(false);
  const [combinedAmount, setCombinedAmount] = useState({});
  const [stateresp, setStateResp] = useState(null);
  const [hide, setHide] = useState(false);
  const [responses, setResponse] = useState([]);
  const [showTransferHistory, setTransferHistory] = useState(false);
  const { handleChange, handleKeyUp, pin, inputRefs } = useOtpHook(4);

  console.log(details, "details");
  const handleOk = () => {
    setIsOpen(false);
  };
  const handleCancel = () => {
    setIsOpen(false);
  };
  const formatNumberWithCommas = (value) => {
    return value.replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  };
  const handleChangeinput = (e) => {
    const sanitized = e.target.value.replace(/[^0-9.]/g, "");
    setOriginalVal(sanitized);
    const formattedValue = formatNumberWithCommas(sanitized);
    setInputValue(formattedValue);
  };
  const handleResendOTP = (val) => {
    console.log(val, "valuable dta");
    setBtnLoading(true);
    const formdata = new FormData();
    formdata.append("transaction_id", val.transaction_id);

    resendOtpDmt2(formdata)
      .then((res) => {
        if (res.status) {
          setStateResp(res.data.stateresp);
          setHide(true);
          setOpenVerifyModal(true);
        }
      })
      .catch((err) => console.log(err))
      .finally(() => setBtnLoading(false));
  };
  const handleTransfer = () => {
    setBtnLoading(true);
    const formdata = new FormData();
    formdata.append("remitter_mobile", mobile);
    formdata.append("bene_id", details?.bene_id);
    formdata.append("txn_type", "IMPS");

    // formdata.append("gst_state", mobile);
    // formdata.append("dob", mobile);
    // formdata.append("address", mobile);
    // formdata.append("pincode", mobile);
    formdata.append("latitude", getLocalStorageItem("latitude"));
    formdata.append("longitude", getLocalStorageItem("longitude"));
    formdata.append("amount", originalVal);

    dmtFundTransfer2Otp(formdata)
      .then((res) => {
        if (res.status) {
          setStateResp(res.data.stateresp);
          setHide(true);
          setOpenVerifyModal(true);
        }
      })
      .catch((err) => console.log(err))
      .finally(() => setBtnLoading(false));
  };

  const handleVerify = (val) => {
    setBtnLoading(true);
    const formdata = new FormData();
    formdata.append("otp", pin.join(""));
    formdata.append("transaction_id", val.transaction_id);

    // Object.keys(otherFields).map((key) =>
    //   formdata.append(key, otherFields[key])
    // );
    Dmt2getRefund(formdata)
      .then((res) => {
        if (res) {
          if (res.status) {
            dispatchtoast("Refund Initiated Successfully", false);

            const result = res.data.reduce(
              (accumulator, transaction) => {
                const status = transaction.status;
                if (status === "SUCCESS") {
                  accumulator.success += transaction.amount;
                } else if (status === "PENDING") {
                  accumulator.pending += transaction.amount;
                } else if (status === "FAILED") {
                  accumulator.failed += transaction.amount;
                }
                return accumulator;
              },
              { success: 0, pending: 0, failed: 0 }
            );
            setResponse(res);
            setCombinedAmount(result);
            setHide(false);
            setShowSuccess(true);
            setIsOpen(false);
          }
        } else {
          dispatchtoast("Something went wrong", true);
        }
      })
      .catch((err) => console.log(err))
      .finally(() => setBtnLoading(false));
  };
  return (
    <>
      <Modal
        title={!showTransferHistory ? "Pay Amount" : "Transfer Status"}
        footer={null}
        className={`shadow-normal dmtmodal ${hide ? "hidden" : ""}`}
        width={300}
        maskClosable={false}
        open={isOpen}
        onOk={handleOk}
        onCancel={handleCancel}
      >
        {!showTransferHistory ? (
          <>
            <div className="userDetail text-center font-semibold text-[13px]"></div>
            <div className="amount mt-4  font-bold text-center">
              <p className="text-3xl">₹</p>
              <input
                onChange={handleChangeinput}
                value={inputValue}
                placeholder="0"
                className="border-none mb-20 text-lg text-center"
              />
            </div>
          </>
        ) : (
          <>
            <div className=" overflow-y-scroll">
              <div className="border border-bsgray300 rounded-md font-semibold shadow-md p-2 h-3/5 overflow-y-scroll leading-10">
                <p>Transfer status</p>
                {Object.keys(combinedAmount).length !== 0 &&
                  Object.keys(combinedAmount).map((key, index) => {
                    return combinedAmount[key] === 0 ? null : (
                      <div key={index}>
                        <div className="flex justify-between items-center">
                          <p>₹ {combinedAmount[key]}</p>
                          <p className="flex justify-center items-center gap-4">
                            {key}{" "}
                            <span>
                              <img
                                src={
                                  key === "success"
                                    ? Images.success
                                    : key === "pending"
                                    ? Images.pending
                                    : Images.failed
                                }
                                className="w-4 h-4"
                              />
                            </span>
                          </p>
                        </div>

                        {index ===
                        Object.keys(combinedAmount).length - 1 ? null : (
                          <hr />
                        )}
                      </div>
                    );
                  })}
                {/* <hr /> */}
              </div>
              <div className="min-h-[100px] max-h-[200px]">
                {responses?.data?.length !== 0 &&
                  responses?.data?.map((i, index) => {
                    return (
                      <div
                        key={index}
                        className="mt-2 border border-bsgray300 rounded-md font-semibold text-xs shadow-md"
                      >
                        <div className="p-2  flex justify-between items-center  ">
                          <div>
                            <p>Amount</p>
                            <p>₹ {i.amount}/-</p>
                            <p>Rupees {numberToWords(i.amount)}</p>
                          </div>
                          <div>
                            <img
                              src={
                                i.status === "SUCCESS"
                                  ? Images.success
                                  : i.status === "PENDING"
                                  ? Images.pending
                                  : Images.failed
                              }
                              className="w-8 h-8"
                              alt="status"
                            />
                            <p>{i.status}</p>
                          </div>
                        </div>
                        <div className=" p-1 font-semibold bg-[#f8fafc] text-bsgray700 text-xs leading-5">
                          <p
                            className={`${
                              i.status === "FAILED"
                                ? "text-red-600"
                                : i.status === "PENDING"
                                ? "text-yellow-400"
                                : "text-green-400"
                            }`}
                          >
                            Remark: {i?.message ?? "-"}
                          </p>
                          <p>Transfer Mode: {i.transfer_mode}</p>
                          <p>TXN: {i.transaction_id}</p>
                          <p>Beneficiary I'd: {i.beneficiary_id}</p>
                          <p>
                            Api Transaction I'd:{" "}
                            {i?.data?.api_transaction_id ?? "NAN"}
                          </p>
                        </div>
                        {i.status !== "REFUND" ? (
                          ""
                        ) : (
                          <>
                            <div className=" mt-5 flex justify-center items-center">
                              {[1, 2, 3, 4].map((i, index) => {
                                return (
                                  <>
                                    <input
                                      key={index}
                                      ref={inputRefs[index]}
                                      type="text"
                                      maxLength={1}
                                      className="w-[15px] otpinput xs:w-[35px] sm:w-[35px] md:w-[40px] text-bsblackrgb rounded-md bg-gray-300 h-8  mx-1 border-none focus:outline-none focus:border-none text-center"
                                      value={pin[index]}
                                      onChange={(e) =>
                                        handleChange(index, e.target.value)
                                      }
                                      onKeyUp={(e) => handleKeyUp(index, e)}
                                    />
                                  </>
                                );
                              })}
                            </div>
                            <Button
                              loading={btnLoading}
                              onClick={() =>
                                pin.length === 4 && handleVerify(i)
                              }
                              className={`SignInBtn w-full ${
                                pin.length === 4
                                  ? "cursor-pointer"
                                  : "cursor-not-allowed"
                              }  mt-4 ${
                                pin.length === 4 ? "bg-primary" : "bg-bsgray"
                              }  flex justify-center border-none items-center h-6 mt-5 rounded-full text-white text-[8px] font-semibold`}
                            >
                              <p>Verify OTP</p>
                            </Button>
                            <p
                              className="font-normal text-xs text-blue-500 underline underline-offset-1 m-2"
                              onClick={() => handleResendOTP(i)}
                            >
                              Resend OTP
                            </p>
                          </>
                        )}
                      </div>
                    );
                  })}
              </div>
            </div>
          </>
        )}
        <div className="">
          {Number(originalVal) > Number(details.limit_available) && (
            <>
              <p className="text-xs text-bsred">
                You can't enter amount larger then your available limit!
              </p>
              <p className="text-xs text-bsred">
                Available Limit : {details.limit_available}
              </p>
            </>
          )}
          {!showTransferHistory ? (
            <Button
              onClick={() => handleTransfer()}
              loading={btnLoading}
              disabled={
                !inputValue ||
                Number(originalVal) > Number(details.limit_available)
              }
              className="w-full  bg-primary mt-2 hover:bg-primaryhover text-bswhite rounded-sm border-none "
            >
              Pay
            </Button>
          ) : (
            <Button
              onClick={() => setIsOpen(false)}
              className="w-full  bg-primary mt-2 hover:bg-primaryhover text-bswhite rounded-sm border-none "
            >
              Go Back
            </Button>
          )}
        </div>
      </Modal>
      {openVerifyModal && (
        <OtpDmt2
          isOpen={openVerifyModal}
          setIsOpen={setOpenVerifyModal}
          setShowSuccess={setTransferHistory}
          setResponse={setResponse}
          setCombinedAmount={setCombinedAmount}
          setpaymodal={setIsOpen}
          setHide={setHide}
          otherFields={{
            latitude: getLocalStorageItem("latitude"),
            longitude: getLocalStorageItem("longitude"),
            amount: originalVal,
            remitter_mobile: mobile,
            bene_id: details.bene_id,
            beneficiary_name: details.name,
            account_no: details.accno,
            ifsc_code: details.ifsc,
            bank_name: details.bankname,
            stateresp: stateresp,
            txn_type: "IMPS",
          }}
          endpoint={Globalendpoints.fundTransfer2}
        />
      )}
    </>
  );
};

export default DmtPayModal2;
